<div [ngClass]="{ 'progress-overlay': progressSpinnerService.showProgress }">
  @if (progressSpinnerService.showProgress) {
    <mat-progress-spinner
      mode="indeterminate"
      diameter="100"
      strokeWidth="8"></mat-progress-spinner>
  }
</div>
